import { Text } from "react-native-paper";

interface Address {
  address1: string;
  address2?: string;
  city: string;
  postalCode?: string;
  state?: string;
}

export const getAddressState = ({ city, state, postalCode }: Address) =>
  state || postalCode ? `${city}, ${state} ${postalCode}` : city;

export default function Address({ address, textClassName }: { address: Address; textClassName?: string }) {
  const className = `text-regular-tight font-400 text-ink-darker ${textClassName ?? ""}`;
  return (
    <>
      <Text className={className}>{address.address1}</Text>
      {address.address2 && <Text className={className}>{address.address2}</Text>}
      <Text className={className}>{getAddressState(address)}</Text>
    </>
  );
}
